/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_Processing_Item_Account_DescInputs */

const en_privacy_data_processing_item_account_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Account_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Name, email address, authentication credentials — Legal basis: Contract performance (Art. 6(1)(b) GDPR)`)
};

const de_privacy_data_processing_item_account_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Account_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Name, E-Mail-Adresse, Authentifizierungsdaten — Rechtsgrundlage: Vertragserfuellung (Art. 6 Abs. 1 lit. b DSGVO)`)
};

const fr_privacy_data_processing_item_account_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Account_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Nom, adresse e-mail, identifiants d'authentification`)
};

const es_privacy_data_processing_item_account_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Account_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Nombre, dirección de correo electrónico, credenciales de autenticación`)
};

const it_privacy_data_processing_item_account_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Account_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Nome, indirizzo email, credenziali di autenticazione`)
};

const nl_privacy_data_processing_item_account_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Account_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Naam, e-mailadres, authenticatiegegevens`)
};

const pl_privacy_data_processing_item_account_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Account_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Imię i nazwisko, adres e-mail, dane uwierzytelniające`)
};

const fi_privacy_data_processing_item_account_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Account_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Nimi, sähköpostiosoite, todennustiedot`)
};

const da_privacy_data_processing_item_account_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Account_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Navn, e-mailadresse, autentificeringsoplysninger`)
};

const sv_privacy_data_processing_item_account_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Account_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Namn, e-postadress, autentiseringsuppgifter`)
};

/**
* | output |
* | --- |
* | "Name, email address, authentication credentials — Legal basis: Contract performance (Art. 6(1)(b) GDPR)" |
*
* @param {Privacy_Data_Processing_Item_Account_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_data_processing_item_account_desc = /** @type {((inputs?: Privacy_Data_Processing_Item_Account_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_Processing_Item_Account_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_data_processing_item_account_desc(inputs)
	if (locale === "fr") return fr_privacy_data_processing_item_account_desc(inputs)
	if (locale === "es") return es_privacy_data_processing_item_account_desc(inputs)
	if (locale === "it") return it_privacy_data_processing_item_account_desc(inputs)
	if (locale === "nl") return nl_privacy_data_processing_item_account_desc(inputs)
	if (locale === "pl") return pl_privacy_data_processing_item_account_desc(inputs)
	if (locale === "fi") return fi_privacy_data_processing_item_account_desc(inputs)
	if (locale === "da") return da_privacy_data_processing_item_account_desc(inputs)
	if (locale === "sv") return sv_privacy_data_processing_item_account_desc(inputs)
	return en_privacy_data_processing_item_account_desc(inputs)
});